import { render, staticRenderFns } from "./PaymentHistoryTab.vue?vue&type=template&id=be981748&"
import script from "./PaymentHistoryTab.vue?vue&type=script&lang=js&"
export * from "./PaymentHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be981748')) {
      api.createRecord('be981748', component.options)
    } else {
      api.reload('be981748', component.options)
    }
    module.hot.accept("./PaymentHistoryTab.vue?vue&type=template&id=be981748&", function () {
      api.rerender('be981748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/dashboard/screens/DashboardScreen/PaymentHistoryTab.vue"
export default component.exports